import "../css/style.scss"

// Our modules / classes
import MobileMenu from "./modules/MobileMenu"
import HeroSlider from "./modules/HeroSlider"
import GMap from "./modules/GoogleMap"
import Search from "./modules/Search"
import MyNotes from "./modules/myNotes"
import Like from "./modules/Like"

// Instantiate a new object using our modules/classes
var mobileMenu = new MobileMenu()
var heroSlider = new HeroSlider()
const googleMap = new GMap()
var search = new Search()
var myNotes = new MyNotes()
var like = new Like()

//alert("just a test")
